import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { services } from './Services';

export const withController = BaseComponent => ({ ...props }) => {
  const location = useLocation();
  const [service, setService] = useState(services[0]);
  useEffect(() => {
    if (location.state !== undefined) {
      const selectedService = services.filter(s => s.value === location.state.service);
      setService(selectedService[0]);
    }
  }, [location]);
  return (
    <BaseComponent service={service} {...props} />
  );
};
